import {
  PageKind,
  StorePage,
} from '@/features/editor/context/use-device-navigation';
import { rmTrailingSlash } from '@/utils/url';

export const PAGE_URL_CAPTION = `Page Url (WITH DOMAIN)`;
export const PAGE_PATH_CAPTION = `Page Path`;
export const PAGE_TYPE_CAPTION = `Page Type`;

const SCHEME_PATTERN = /^https?:\/\//;

export const hasScheme = (url: string) => SCHEME_PATTERN.test(url);

export const toFullUrl = (url: string) =>
  hasScheme(url) ? url : `https://${url}`;

export const stripScheme = (url: string) => url.replace(SCHEME_PATTERN, ``);

export const safeDecode = (text: string) => {
  try {
    return decodeURIComponent(text);
  } catch {
    return text;
  }
};

const parseUrl = (url: string) => {
  try {
    return new URL(toFullUrl(url));
  } catch {
    return undefined;
  }
};

export const getPathname = (url: string) =>
  safeDecode(parseUrl(url)?.pathname || ``);

export const toPathWithParams = (url: string) => {
  const parsedUrl = parseUrl(url);
  return parsedUrl ? `${parsedUrl.pathname}${parsedUrl.search}` : url;
};

export const getUrlWithoutScheme = (url: string) =>
  rmTrailingSlash(safeDecode(stripScheme(url)));

export const isSameHost = (url: string, domain: string) =>
  parseUrl(url)?.hostname === parseUrl(domain)?.hostname;

export const isNotCheckoutPage = (page: StorePage) =>
  page.kind !== PageKind.CHECKOUT;
